import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import router from "@/router";
import JWTDecode from "jwt-decode";
import { onBeforeMount } from "vue";
import { JWTToken } from "@/interfaces";
import { useClientStore } from "@/store/ClientStore";
import { storeToRefs } from "pinia";

const __default__ = {
  name: "AuthenticatedPageWrapper",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { pageLoading } = storeToRefs(useClientStore());
const { loadUserData, logoutUser } = useClientStore();

onBeforeMount(async () => {
  pageLoading.value = true;
  if (checkExpireToken()) {
    console.log(checkExpireToken());
    logoutUser();
    await router.push({ name: "SignIn" });
  } else {
    loadUserData();
  }
  pageLoading.value = false;
});

const checkExpireToken = () => {
  const decoded = JWTDecode<JWTToken>(localStorage.getItem("token"));
  const currentTime = Date.now() / 1000;
  return decoded.iat + 900 < currentTime;
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_router_view)
  ]))
}
}

})